import { message } from 'antd';
import { find, get, isEmpty } from 'lodash';

import { ISankeyRequestBody } from '@src/emp-3.0/types';
import { DURATION_ALLOWED_IN_DAYS } from '@src/emp-3.0/components/Sankey/constants';
import moment from 'moment';
import queryString from 'query-string';

const MESSAGE = 'Please specify a dimension value for landing event before generating chart.';

export const verifySankeyPayload = (data: ISankeyRequestBody) => {
  const { landing_events, event_breakdown, interval } = data;
  const matchedEventBreakdown = find(event_breakdown, { event_name: landing_events[0].event_name });

  const isValidationFailed = landing_events[0].filters.some((item) => {
    const field = get(item, '[0].field');
    const value = get(item, '[0].value');

    return (matchedEventBreakdown?.breakdowns ?? []).some(
      (breakdown) =>
        field === get(breakdown, '[0].field') &&
        isEmpty(value) &&
        (!isEmpty(get(breakdown, '[0].value')) ||
          (isEmpty(get(breakdown, '[0].value')) && get(breakdown, '[0].is_all'))),
    );
  });
  if (isValidationFailed) {
    message.error(MESSAGE);
  }
  return {
    validation: !isValidationFailed,
    message: MESSAGE,
  };
};

export const isInactiveInterval = (interval, calenderBoundry) => {
  let [intervalStart, intervalEnd] = interval.split('/');
  intervalStart = moment(intervalStart);
  intervalEnd = moment(intervalEnd);
  const boundryStart = moment(calenderBoundry.start_time);
  const boundryEnd = moment(calenderBoundry.end_time);
  if (intervalEnd.isBefore(boundryStart) || intervalStart.isAfter(boundryEnd)) {
    return true;
  }
  return false;
};

export const addShareId = (payload: any) => {
  const { share_id } = queryString.parse(window.location.search);
  // if interval is older than 14 days, then add share_id
  let oldInterval = false;
  let [intervalStart, intervalEnd] = payload.interval.split('/');
  intervalStart = moment(intervalStart);
  intervalEnd = moment(intervalEnd);
  const past14Days = moment().subtract(14, 'days').startOf('day');
  if (intervalStart < past14Days || intervalEnd < past14Days) {
    oldInterval = true;
  }
  if (share_id && payload && oldInterval) {
    payload.share_id = +share_id;
  }
  return payload;
};

export const getDurationAllowedInDays = (customerId) => {
  // this should be replaced by feature flag after 2 july 2025.
  if ([1960188605, 1960188617, 1960185019].includes(customerId)) return 90;
  return DURATION_ALLOWED_IN_DAYS;
};
